import { useTranslation } from 'react-i18next';
import { useRouteHook } from '@shared/hooks';
import { cn, RoutePaths } from '@shared/utils';
import { Button, Icon, Modal, Text } from '@shared/widgets';
import CheckIcon from '@assets/icons/check.svg';

interface RequestSubmittedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RequestSubmittedModal = (props: RequestSubmittedModalProps) => {
  const { navigate } = useRouteHook();

  const { t } = useTranslation('travel');

  const closeHandler = () => {
    navigate(RoutePaths.travelMyRequests.onNavigate());
    props.onClose();
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={closeHandler}
      className={cn('p-8', 'max-md:p-6')}
      headerClassName='hidden'
      mainClassName='flex flex-col gap-6'
    >
      <Icon
        className='mx-auto flex size-16 items-center justify-center rounded-full bg-dark-emerald'
        color='green'
        icon={<CheckIcon className='size-6' />}
      />
      <div className='flex flex-col gap-2'>
        <Text tag='h3' center weight='semibold' size='2xl'>
          {t('requestSubmittedModal.title')}
        </Text>
        <Text className='max-w-[370px]' center tag='p'>
          {t('requestSubmittedModal.description')}
        </Text>
      </div>
      <Button color='primary' fullWidth onClick={closeHandler}>
        {t('requestSubmittedModal.button')}
      </Button>
    </Modal>
  );
};
